import * as React from "react"

export default function HamburgerMenu({ items, active, onSelect }) {
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") setOpen(false)
    }
    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [])

  function handleSelect(value) {
    onSelect(value)
    setOpen(false)
  }

  return (
    <>
      {/* Botão sticky */}
      <button
        onClick={() => setOpen(true)}
        aria-label="Abrir menu"
        type="button"
        className="fixed top-6 right-6 z-40 w-12 h-12 rounded-full bg-cor-base text-slate-100 shadow-2xl flex items-center justify-center active:scale-[.92] transition-all hover:scale-[1.05]">
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      {/* Backdrop */}
      {open && (
        <div
          className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Drawer */}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 max-w-[80vw] bg-slate-50 shadow-2xl transform transition-transform duration-75 ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}>
        <div className="flex items-center justify-between px-5 py-4 bg-cor-base">
          <span className="text-white font-oswald font-semibold tracking-wide">
            Menu
          </span>
          <button
            onClick={() => setOpen(false)}
            className="text-white/70 hover:text-white text-2xl leading-none transition-colors"
            aria-label="Fechar menu"
            type="button">
            X
          </button>
        </div>

        <nav className="p-3 grid gap-1">
          {items.map((item) => {
            const isActive = item.value === active
            return (
              <button
                key={item.value}
                onClick={() => handleSelect(item.value)}
                type="button"
                disabled={item.disabled}
                className={`text-left px-4 py-3 rounded-xl font-semibold transition-all ${
                  item.value === "logout"
                    ? "text-red-600 hover:bg-red-50"
                    : isActive
                      ? "bg-cor-base text-slate-100"
                      : item.disabled
                        ? "text-slate-400 cursor-not-allowed"
                        : "text-slate-700 hover:bg-slate-200"
                }`}>
                {item.label}
                {item.badge && (
                  <span className="ml-2 text-xs uppercase tracking-wide text-slate-400">
                    {item.badge}
                  </span>
                )}
              </button>
            )
          })}
        </nav>
      </div>
    </>
  )
}
